import { useMemo } from "react";
import { twMerge } from "tailwind-merge";

export const StockStatusIcon = ({
  availableStock,
  canBackorder,
}: {
  availableStock: number;
  canBackorder: boolean;
}) => {
  const { innerColour, outerColour } = useMemo(() => {
    if (availableStock > 10 || canBackorder) {
      return {
        innerColour: "bg-green-800",
        outerColour: "bg-green-200",
      };
    }

    if (availableStock > 0) {
      return {
        innerColour: "bg-amber-800",
        outerColour: "bg-amber-100",
      };
    }

    return {
      innerColour: "bg-red-800",
      outerColour: "bg-red-200",
    };
  }, [availableStock, canBackorder]);

  return (
    <div className="flex items-center justify-center">
      <div
        className={twMerge(
          "relative flex h-5 w-5 items-center justify-center rounded-full bg-blue-500",
          outerColour,
        )}
      >
        <div className={twMerge("h-2.5 w-2.5 rounded-full", innerColour)}></div>
      </div>
    </div>
  );
};

export const StockStatusCard = ({
  availableStock,
  committedStock,
  canBackorder,
}: {
  availableStock: number;
  committedStock: number;
  canBackorder: boolean;
}) => {
  return (
    <div className="grid grid-cols-[auto_1fr] items-center justify-center gap-x-2 rounded-lg border border-solid border-zinc-300 p-4">
      <div className="col-start-1 col-end-2 row-start-1 row-end-2">
        <StockStatusIcon
          availableStock={availableStock}
          canBackorder={canBackorder}
        />
      </div>
      <div className="col-start-2 col-end-3 font-semibold text-zinc-800">
        Stock available to customers:{" "}
        {canBackorder ? "Available" : availableStock}
      </div>
      {!!committedStock && (
        <div className="col-start-2 col-end-3 text-zinc-500">
          Committed stock: {committedStock}
        </div>
      )}
      {canBackorder && (
        <div className="col-start-2 col-end-3 text-sm text-zinc-700">
          No limits on stock meaning customers can order freely.
        </div>
      )}
    </div>
  );
};
